module.exports = __webpack_public_path__ + "static/media/5.64987428.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/existLogos/5.jpg
// module id = 981
// module chunks = 4